import React, { useState, useEffect } from "react";
import { styled, useTheme } from '@mui/material/styles';

import Subcategory from "./downloads/Subcategory";

const PREFIX = 'AnalysisPinned';

const classes = {
  root: `${PREFIX}-root`,
  analysis: `${PREFIX}-analysis`,
  summary: `${PREFIX}-summary`,
  header: `${PREFIX}-header`,
  content: `${PREFIX}-content`
};

const Root = styled('div')((
  {
    theme
  }
) => ({

  [`& .${classes.analysis}`]: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    justifyContent: "space-between",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },

  [`& .${classes.summary}`]: {
    width: "15em",
    height: "auto",
    flex: 0,
  },

  [`& .${classes.header}`]: {
    fontWeight: "normal",
    fontSize: "1rem",
    display: "block",
    marginBottom: "1em",
    textTransform: "uppercase",
  },

  [`& .${classes.content}`]: {
    display: "flex",
    flexWrap: "wrap",
    flex: 1,
  }
}));

const AnalysisPinned = ({ analysis }) => {
	
  const theme = useTheme();
  const [toRender, setToRender] = useState([]);

  useEffect(() => {
    if (analysis && analysis.downloads && analysis.downloads.length > 0) {
      const allSubcategories = analysis.downloads.map(
        (download) => download.subcategory
      );
      const uniqueSubcategories = Array.from(new Set(allSubcategories));

      const downloadsBySubcategory = [];
      uniqueSubcategories.forEach((subcategory) => {
        const filteredDownloads = analysis.downloads.filter(
          (download) => download.subcategory === subcategory
        );
        downloadsBySubcategory.push(filteredDownloads);
      });

      const _toRender = [];
      uniqueSubcategories.forEach((subcategory, idx) => {
        _toRender.push(
          <Subcategory
            subcategory={subcategory}
            downloads={downloadsBySubcategory[idx]}
          />
        );
      });
      setToRender(_toRender);
    }
  }, [analysis, analysis.downloads]);

  return (
    <Root className={classes.root}
	sx={{
		background: "#fff",
	    marginTop: "1em",
	    position: "relative",
	    padding: "1em",
	    border: "2px solid #e9e9e9",
	    borderRadius: "5px",
	    overflow: "auto",
	    display: "flex",
	    flex: 1,
	    "& > *": {
	      margin: theme.spacing(1),
	      width: theme.spacing(16),
	      height: theme.spacing(16),
	    },
	    [theme.breakpoints.down("sm")]: {
	      width: "auto",
	    },
	}}>
	      <div className={classes.analysis}>
	        <div className={classes.summary}>
	          <span className={classes.header}>Event Downloads and Links</span>
	        </div>
	        <div className={classes.content}>
	          {toRender.length > 0 ? toRender : null}
	        </div>
	      </div>
    </Root>
  );
};

export default AnalysisPinned;
